<template>
  <div>
    <div class="mb-2">
      <v-layout align-center wrap class="my-4">
        <v-flex sm6 md3 class="pr-2">
          <div class="caption">Group</div>
          <multiselect
            v-model="filterAgentGroup"
            :options="agentGroupOptions"
            select-label
            selected-label
            :allow-empty="true"
            :searchable="true"
            deselect-label
            label="groupname"
            placeholder="select group"
            :disabled="isAgent"
            @input="handleFetchData()"
          ></multiselect>
        </v-flex>
        <v-flex sm6 md3 class="pl-2">
          <div class="caption">Agent</div>
          <multiselect
            v-model="filterAgent"
            :options="agentOptions"
            select-label
            selected-label
            :allow-empty="true"
            :searchable="true"
            deselect-label
            @input="handleFetchData()"
          ></multiselect>
        </v-flex>
        <v-flex sm12 md6 style="display: flex" class="justify-end">
          <v-btn outline color="primary" class="ma-0 mb-1" @click="handleExport">
            <em class="fas fa-file-export mr-1" />
            {{ $t('export') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </div>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      class="elevation-1"
      :pagination.sync="pagination"
      hide-actions
    >
      <template #items="props">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.pending }}</td>
        <td class="text-xs-right">{{ props.item.answered }}</td>
        <td class="text-xs-right">{{ props.item.close_with_survey }}</td>
        <td class="text-xs-right">{{ props.item.close_without_survey }}</td>
        <td class="text-xs-right">{{ props.item.transfer }}</td>
        <td class="text-xs-right">
          {{
            props.item.firsttime && props.item.totalFirstResponseTicket
              ? formatAvg(props.item.firsttime / props.item.totalFirstResponseTicket)
              : formatAvg(0)
          }}
        </td>
        <td class="text-xs-right">
          {{
            props.item.closetime && props.item.closed
              ? formatAvg(props.item.closetime / props.item.closed)
              : formatAvg(0)
          }}
        </td>
        <td class="text-xs-right">{{ props.item.total_sl }}</td>
        <td class="text-xs-right">{{ props.item.total_over_sl }}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ttbApi from '@/api/ttb'
import dayjs from 'dayjs'
import { DATETIME } from '@/constants/datetime'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import XLSX from 'xlsx'

export default {
  components: {
    Multiselect
  },
  filters: {
    timer(value) {
      const hours = Math.floor(value / 60 / 60) % 60
      const minutes = Math.floor(value / 60) % 60
      const seconds = value % 60
      const padZero = (number) => (number > 99 ? number : number.toString().padStart(2, '0'))
      return `${padZero(hours)}h ${padZero(minutes)}m ${padZero(seconds)}s`
    }
  },
  props: {
    selectedDate: {
      type: Object,
      default: () => ({
        end: dayjs().format('YYYY-MM-DD'),
        start: dayjs().subtract(7, 'days').format('YYYY-MM-DD')
      })
    }
  },
  data() {
    return {
      items: [],
      loading: false,
      filterAgent: '',
      filterAgentGroup: { groupname: 'All', id: '' },
      pagination: { rowsPerPage: -1, sortBy: '' },
      localPagination: {
        page: 1,
        totalItems: 0,
        rowsPerPage: 10,
        ...this.pagination
      },
      headers: [
        { text: 'Agent', value: 'agent', sortable: false },
        { text: 'Pending', value: 'pending', align: 'center', sortable: false },
        { text: 'Answered', value: 'answered', align: 'center', sortable: false },
        {
          text: 'Closed with survey',
          value: 'close_with_survey',
          align: 'center',
          sortable: false
        },
        {
          text: 'Closed without survey',
          value: 'close_without_survey',
          align: 'center',
          sortable: false
        },
        { text: 'Tickets transfer', value: 'transfer', align: 'center', sortable: false },
        {
          text: 'AVG first response time',
          value: 'avgFirstResponseTime',
          align: 'right',
          sortable: false
        },
        {
          text: 'AVG resolved ticket time',
          value: 'avgResolvedTicketTime',
          align: 'right',
          sortable: false
        },
        {
          text: 'Closed case within SL',
          value: 'total_sl',
          align: 'center',
          sortable: false
        },
        { text: 'Closed case over SL', value: 'total_over_sl', align: 'center', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    totalPages() {
      const { totalItems, rowsPerPage } = this.localPagination
      return Math.ceil(totalItems / rowsPerPage)
    },
    agentGroupList() {
      return this.$store.state.agentGroups
    },
    agentGroupOptions() {
      if (this.agentGroupList && this.agentGroupList.length > 0) {
        return [{ groupname: 'All', id: '' }, ...this.agentGroupList]
      }
      return [{ groupname: 'All', id: '' }]
    },
    agentList() {
      if (this.filterAgentGroup.groupname === 'All') {
        return this.$store.state.agents
          .map((el) => {
            return {
              ...el,
              privilege: JSON.parse(el.privilege)
            }
          })
          .filter((el) => !!el.privilege && el.privilege.role === 'agent')
      }
      return this.$store.state.agents
        .map((el) => {
          return {
            ...el,
            privilege: JSON.parse(el.privilege)
          }
        })
        .filter((el) => !!el.groupname && el.groupname === this.filterAgentGroup.groupname)
        .filter((el) => !!el.privilege && el.privilege.role === 'agent')
    },
    agentOptions() {
      return this.agentList.map((el) => el.adminid)
    },
    isAgent() {
      return this.$store.state.privilege && this.$store.state.privilege.role == 'agent'
    }
  },
  watch: {
    pagination(value) {
      this.localPagination = {
        page: 1,
        totalItems: 0,
        rowsPerPage: 10,
        ...value
      }
    },
    selectedDate: {
      handler() {
        this.handleFetchData()
      },
      deep: true
    }
  },
  mounted() {
    this.handleFetchData()
  },
  methods: {
    async handleFetchData() {
      const vm = this
      try {
        if (this.isAgent) {
          vm.filterAgent = vm.$store.state.userid
        }

        vm.loading = true
        const responseData = await vm.getCountTicketStatusByAgent()

        if (responseData) {
          const result = vm.calculateTicket(responseData)
          vm.items = result
        }
        vm.loading = false
      } catch (error) {
        vm.loading = false
        console.error(error)
      }
    },
    async getCountTicketStatusByAgent() {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          start_date: dayjs(vm.selectedDate.start).format(DATETIME.DATE_FORMAT),
          end_date: dayjs(vm.selectedDate.end).format(DATETIME.DATE_FORMAT)
        }

        if (this.filterAgentGroup && this.filterAgentGroup.id) {
          Object.assign(data, { admin_group_id: this.filterAgentGroup.id })
        }
        if (this.filterAgent) {
          Object.assign(data, { admin_id: this.filterAgent })
        }

        const response = await ttbApi.getCountTicketStatusByAgent({ params: data })
        if (response && response.status === 200 && response.data) {
          return response.data.data
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    calculateTicket(data) {
      var list = {}
      var agents = []
      data.map((el) => {
        if (list.hasOwnProperty(el.adminid)) {
          list[el.adminid].transfer += parseInt(el.transferticket)
          list[el.adminid].firsttime += parseInt(el.firsttime)
          list[el.adminid].closetime += parseInt(el.closetime)
          list[el.adminid].cold_case += parseInt(el.cold_case)
          list[el.adminid].total_sl += parseInt(el.sl)
          list[el.adminid].total_over_sl += parseInt(el.over_sl)
          list[el.adminid].all += parseInt(el.amount)
          list[el.adminid].totalticket += 1
          list[el.adminid].totalFirstResponseTicket += parseInt(el.amount)
          list[el.adminid].all += parseInt(el.amount)
          switch (el.status) {
            case 'pending':
              list[el.adminid].pending += parseInt(el.amount)
              break
            case 'answered':
              list[el.adminid].answered += parseInt(el.amount)
              break
            case 'closed':
              list[el.adminid].closed += parseInt(el.amount)
              list[el.adminid].averageclosetime = (
                parseFloat(el.closetime) / parseFloat(el.amount)
              ).toFixed(2)
              break
            case 'cancelled':
              list[el.adminid].cancelled += parseInt(el.amount)
              break
            case 'cancelled by customer':
              list[el.adminid].cancelledbycustomer += parseInt(el.amount)
              break
            case 'closed with survey':
              list[el.adminid].close_with_survey += parseInt(el.amount)
              break
            case 'closed without survey':
              list[el.adminid].close_without_survey += parseInt(el.amount)
              break

            default:
              break
          }
        } else {
          list[el.adminid] = {
            adminid: el.adminid,
            name: el.name,
            all: parseInt(el.amount),
            pending: 0,
            closed: 0,
            cold_case: 0,
            answered: 0,
            cancelled: 0,
            cancelledbycustomer: 0,
            averageclosetime: 0,
            transfer: 0,
            firsttime: 0,
            closetime: 0,
            total_sl: 0,
            total_over_sl: 0,
            totalticket: 0,
            totalFirstResponseTicket: 0,
            close_with_survey: 0,
            close_without_survey: 0
          }
          list[el.adminid].transfer += parseInt(el.transferticket)
          list[el.adminid].firsttime += parseInt(el.firsttime)
          list[el.adminid].closetime += parseInt(el.closetime)
          list[el.adminid].cold_case += parseInt(el.cold_case)
          list[el.adminid].total_sl += parseInt(el.sl)
          list[el.adminid].total_over_sl += parseInt(el.over_sl)
          list[el.adminid].totalticket += 1
          list[el.adminid].totalFirstResponseTicket += parseInt(el.amount)

          switch (el.status) {
            case 'pending':
              list[el.adminid].pending += parseInt(el.amount)
              break
            case 'closed':
              list[el.adminid].closed += parseInt(el.amount)
              list[el.adminid].averageclosetime = (
                parseFloat(el.closetime) / parseFloat(el.amount)
              ).toFixed(2)
              break
            case 'answered':
              list[el.adminid].answered += parseInt(el.amount)
              break
            case 'cancelled':
              list[el.adminid].cancelled += parseInt(el.amount)
              break
            case 'cancelled by customer':
              list[el.adminid].cancelledbycustomer += parseInt(el.amount)
              break
            case 'closed with survey':
              list[el.adminid].close_with_survey += parseInt(el.amount)
              break
            case 'closed without survey':
              list[el.adminid].close_without_survey += parseInt(el.amount)
              break

            default:
              break
          }
        }
      })

      for (const key in list) {
        if (list.hasOwnProperty(key)) {
          const element = list[key]
          agents.push(element)
        }
      }

      return agents
    },
    formatAvg(secs) {
      const formatted = moment.utc(parseInt(secs) * 1000).format('H ชั่วโมง m นาที s วินาที')
      return formatted
    },

    async handleExport() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.getCountTicketStatusByAgent()
        const responseData = vm.calculateTicket(response)

        if (responseData === null) {
          vm.$store.commit('CLEAR_LOADING')
          return
        }

        const data = responseData.map((el) => {
          return {
            agent: el.name,
            pending: el.pending,
            answered: el.answered,
            close_with_survey: el.close_with_survey,
            close_without_survey: el.close_without_survey,
            transfer: el.transfer,
            average_first_response_time: this.formatAvg(el.firsttime / el.totalticket),
            average_resolved_ticket_time: this.formatAvg(el.closetime / el.totalticket),
            total_sl: el.total_sl,
            total_over_sl: el.total_over_sl,
            total: el.total_sl + el.total_over_sl
          }
        })

        const heading = [
          [
            'Agent',
            'Pending',
            'Answered',
            'Closed with survey',
            'Closed without survey',
            'Ticket transfer',
            'Average first response time',
            'Average resolved ticket time',
            'case within SL',
            'case over SL',
            'Total'
          ]
        ]
        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, data, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `agent-performance.xlsx`)
        vm.$store.commit('CLEAR_LOADING')
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/Agents/Performance/DataTable.vue